import { render, staticRenderFns } from "./ForbiddenGoodsTableSection.vue?vue&type=template&id=369a95f8&scoped=true"
import script from "./ForbiddenGoodsTableSection.vue?vue&type=script&lang=js"
export * from "./ForbiddenGoodsTableSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369a95f8",
  null
  
)

export default component.exports